{
  "version": 1,
  "asset_id": "5f50e5ab-64fc-4274-a231-8d70adbd2360",
  "project_id": "81e5f51e-81a3-47ad-9e0d-7249ca4c0a70",
  "url": "/__l5e/assets-v1/5f50e5ab-64fc-4274-a231-8d70adbd2360/ideal.svg",
  "r2_key": "a/v1/81e5f51e-81a3-47ad-9e0d-7249ca4c0a70/5f50e5ab-64fc-4274-a231-8d70adbd2360/ideal.svg",
  "original_filename": "ideal.svg",
  "size": 2551,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-30T15:11:20Z"
}
